<template lang="pug">
    div.complete-distribution
        ConfirmDialog(
                ref="confirmDialog"
                :dialogWidth="497"
                @confirmSubmit="completeConfirm"
                operateName="请确认商品已配货完成"
                @cancel="handleCancel"
            )
                div.text-desc(slot="text-desc")
                    div.form-container(v-if="showConfirm && currentOrder && currentOrder.deliveryWayKey === 'EXPRESS'")
                        el-form(
                            :model="formData"
                            :rules="rules"
                            ref="form"
                            label-width="94px"
                        )
                            el-form-item(
                                label="发货门店："
                                prop="shopId"
                            )
                                el-select(
                                    v-model="formData.shopId"
                                    placeholder="请选择"
                                )
                                    el-option(
                                        v-for="item in shopList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    )
</template>

<script>
import { goodsApis, orderApis } from '@/api';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
    name: 'CompleteDistribution',
    props: {
        showConfirm: {
            type: Boolean,
            default: false,
        },
        currentOrder: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        ConfirmDialog,
    },
    data() {
        return {
            formData: {
                shopId: undefined,
            },
            rules: {
                shopId: [
                    { required: true, message: '请选择门店', trigger: 'change' },
                ],
            },
            shopList: [],
        };
    },
    created() {

    },
    watch: {
        currentOrder: {
            deep: true,
            immediate: true,
            async handler(val) {
                if (val && val.deliveryWayKey === 'EXPRESS') {
                    const { data } = await goodsApis.getGoodsById(val.orderItems[0].spuId);
                    if (data) {
                        this.shopList = (data.orgDetailDTOS || []).map(v => ({
                            ...v,
                            label: v.orgName,
                            value: v.orgId,
                        }));
                    }
                }
            },
        },
    },
    methods: {
        async completeConfirm() {
            if (this.currentOrder.deliveryWayKey === 'EXPRESS') {
                this.$refs.form.validate(async (valid) => {
                    if (!valid) { return; }
                    const selectedShop = this.shopList.find(v => v.value === this.formData.shopId) || {};
                    const shopData = {
                        shopName: selectedShop.orgName,
                        shopContract: selectedShop.orgPhone,
                        shopAddress: selectedShop.address,
                        shopId: selectedShop.orgId,
                    };
                    this.submit(shopData);
                });
            } else {
                this.submit();
            }
        },
        async submit(shopData) {
            try {
                this.$refs.confirmDialog.buttonLoading = true;
                const res = await orderApis.orderDistribution({
                    ...shopData,
                    id: this.currentOrder.id,
                });
                if (res.code === 0) {
                    this.$emit('refresh');
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                    });
                }
            } catch (error) {
                throw new Error(error);
            } finally {
                this.$refs.confirmDialog.buttonLoading = false;
                this.$refs.confirmDialog.dialogVisible = false;
                this.currentOrder = {};
            }
        },
        handleCancel() {
            this.formData = {
                shopId: undefined,
            };
            this.$emit('cancel');
        },
    },
};
</script>

<style lang="scss" scoped>
.complete-distribution {
    .form-container {
            border-top: 1px solid rgba(0,0,0,0.06);
            padding-top: 20px;
            margin-top: 20px;
            height: 71px;
            .el-form .el-form-item {
                margin-bottom: 0;
            }
        }
}
</style>
